<template>
  <v-card class="d-flex pa-2 flex-column" outlined>

    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch"
      @showType="showType"
      :filters="filterConfig"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
    >
      <template v-slot:action="{ item }">
        <td>
          <v-icon small class="mr-2" @click="goToDetail(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="openDialog('edit', item)">
            mdi-pencil
          </v-icon>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="800px" persistent >
      <v-card>
        <v-card-title class="sticky-header">
          Edit Data Merchant
        </v-card-title>
        <v-divider class="sticky-header-divider"></v-divider>

        <v-card-text class="scrollable-content">
          <v-form ref="form">
             <v-text-field
              v-if="hasAggregator"
              v-model="formData.aggregator_name"
              label="Aggregator Name"
              disabled
              outlined
            />
             <v-text-field
              v-model="formData.merchant_name"
              label="Merchant Name"
              disabled
              outlined
            />
            <v-text-field
              v-model="formData.mid"
              label="MID"
              disabled
              outlined
            />
        
            <v-text-field
              v-model="formData.email"
              label="Email"
              disabled
              outlined
            />
   
            <v-select
              v-model="formData.client_type"
              :items="clientType"
              item-text="text"
              item-value="value"
              label="Client Type"
              :rules="[rules.required]"
              outlined
            />
            <v-text-field
              v-if="showCredential"
              v-model="formData.hidden_inbound_client_id"
              label="Client ID"
              disabled
              outlined
            />
            <v-text-field
              v-if="showCredential"
              v-model="formData.hidden_inbound_merchant_secret_key"
              label="Merchant Secret Key"
              disabled
              outlined
            />
            <v-textarea
             v-if="showCredential"
              v-model="formData.outbound_public_key"
              label="Merchant Public Key *"
              readonly
              rows="2"
              outlined
              :rules="[rules.required, rules.pemKey]"
            />
            <v-btn
              v-if="showCredential && isSnap"
              color="primary"
              class="mb-12 rounded-pill elevation-0"
              :loading="loadingGenerate"
              @click="generateSnapKey"
              :disabled="!allowGenerate"
            >
              Generate Credential SNAP
            </v-btn>
            
            <CallbackPartnerFields
              v-if="isSnap"
              :callbackPartnerId.sync="formData.callback_partner_id"
              :callbackPartnerSecret.sync="formData.callback_partner_secret"
              :rules="[rules.required]"
            />

            <v-text-field
              v-if="isSnap"
              v-model="formData.callback_partner_url_token"
              label="Callback Partner URL Token *"
              outlined
              :rules="[rules.required, rules.endpoint]"
            />
            <v-textarea
              v-if="isSnap"
              v-model="formData.inbound_merchant_public_key"
              label="Public Key Partner *"
              rows="4"
              outlined
              :rules="[rules.required]"
            />
            <v-text-field
              v-model="formData.callback_url"
              label="URL *"
              outlined
              :rules="[rules.required, rules.endpoint]"
            />
          </v-form>
          <v-progress-linear
            v-if="dialogLoading"
            indeterminate
            color="primary"
            class="mt-3"
          ></v-progress-linear>
        </v-card-text>

        <!-- Sticky Footer -->
        <v-divider class="sticky-footer-divider"></v-divider>
        <v-card-actions class="sticky-footer">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="rounded-pill elevation-0" @click="closeDialog">Cancel</v-btn>
          <v-btn
            color="primary"
            class="rounded-pill elevation-0"
            :disabled="dialogLoading"
            @click="saveData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-dialog v-model="confirmDialog" max-width="500px" persistent>
  <v-card>
    <v-card-title class="text-h6 text-center justify-center">
      Confirm Action!
    </v-card-title>
    <v-card-text class="text-center">
      {{ hasAggregator 
        ? "Anda akan melakukan generate credential API baru untuk akun Aggregator ini. Tindakan ini juga akan mengubah credential seluruh submerchant di bawah aggregator."
        : "Anda akan melakukan generate credential API baru untuk akun merchant ini. Tindakan ini juga akan mengubah credential merchant ini" 
      }}
    </v-card-text>
    <v-card-actions class="justify-center pb-6">
      <v-btn
        color="error"
        class="rounded-pill elevation-0 text-none mx-2"
        @click="confirmDialog = false"
      >
        Batal
      </v-btn>
      <v-btn
        color="primary"
        class="rounded-pill elevation-0 text-none mx-2"
        @click="handleConfirm"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  </v-card>
</template>
<script>
import merchantCallbackMixin from '../../components/merchant-callback-management/merchantCallbackMixin';

export default {
  mixins: [ merchantCallbackMixin ],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    CallbackPartnerFields: () => import("../../components/merchant-callback-management/CallbackPartnerFields.vue"),
  },
  methods: {
    goToDetail(item) {
      this.$router.push(`/management-merchant-api/detail/${item.client_id}`);
    }
  }
};
</script>

<style scoped>

.v-text-field input {
    font-size: 12px;
  }

.scrollable-content {
  max-height: 580px;
  overflow-y: auto;
  padding: 32px !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  padding: 12px;
  font-weight: 500;
}
.sticky-header-divider {
  position: sticky;
  top: 56px; 
  z-index: 1;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 2;
  padding: 16px 12px 16px 12px!important;
}
.sticky-footer-divider {
  position: sticky;
  bottom: 48px;
  z-index: 1;
}
</style>